module.exports = __webpack_public_path__ + "img/borderObliqueCornerWhite.faf38eeb.svg";